import { Link } from "react-router";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { ArrowRight, Calendar } from "lucide-react";
import { APPOINTMENT_STATUS_COLORS, APPOINTMENT_STATUS_LABELS, type AppointmentStatus } from "@bookdental/schemas";
import { trpc } from "@/lib/trpc";
import { AcaoDoRodape, Card, CardEmpty, CardLoading, Rodape } from "./QuadroBase";
import type { QuadroProps } from "./tipos";
import { PilulaDeStatus } from "@/components/prosthesis/PilulaDeStatus";

/** Próximas consultas do paciente. */
export function QuadroConsultas({ patientId, menu, onAgendar }: QuadroProps & { onAgendar: () => void }) {
  const query = trpc.appointment.upcomingByPatient.useQuery({ patientId, take: 4 });

  return (
    <Card icon={<Calendar className="h-4 w-4" />} title="Consultas agendadas" tone="brand" menu={menu}>
      {query.isLoading ? (
        <CardLoading />
      ) : !query.data || query.data.length === 0 ? (
        <CardEmpty icon={<Calendar className="h-6 w-6" />} text="Nenhuma consulta agendada" hint="As próximas consultas aparecerão aqui" />
      ) : (
        <ul className="space-y-2.5">
          {query.data.map((appt: any) => {
            const status = (appt.status ?? "SCHEDULED") as AppointmentStatus;
            const color = APPOINTMENT_STATUS_COLORS[status];
            return (
              <li
                key={appt.id}
                className="flex items-start gap-3 rounded-lg border border-zinc-100 bg-white p-2.5 transition-colors hover:border-brand-200 hover:bg-brand-50/30 dark:border-border dark:bg-card"
              >
                <div className="min-w-0 flex-1">
                  <div className="flex items-center justify-between gap-2">
                    <p className="truncate text-[11px] font-medium text-zinc-500 dark:text-muted-foreground">
                      {format(new Date(appt.date), "EEE dd MMM yyyy", { locale: ptBR })}
                      {" · "}
                      {appt.startTime}–{appt.endTime}
                    </p>
                    <PilulaDeStatus rotulo={APPOINTMENT_STATUS_LABELS[status]} cor={color} fundo={`${color}1a`} className="px-2 text-[11px]" />
                  </div>
                  <p className="mt-0.5 truncate text-sm font-medium text-zinc-900 dark:text-foreground">{appt.procedure}</p>
                  {appt.dentistName && <p className="truncate text-[11px] text-zinc-500 dark:text-muted-foreground">{appt.dentistName}</p>}
                </div>
              </li>
            );
          })}
        </ul>
      )}

      <Rodape>
        <Link to="/agenda" className="inline-flex items-center gap-1 text-[11px] font-medium text-brand-700 hover:text-brand-900 dark:text-primary">
          Ver todas na agenda
          <ArrowRight className="h-3 w-3" />
        </Link>
        <AcaoDoRodape rotulo="Agendar" onClick={onAgendar} />
      </Rodape>
    </Card>
  );
}
